import Konva from 'konva';
import GraphicBase from './base';
import * as PanoramaUrl from '../assets/arrow.png';

function lineRad(x1, y1, x2, y2) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  return Math.atan2(dy, dx) * (180 / Math.PI);
}

class GraphicLine extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = false;
  }

  build() {
    const { data, id, stage } = this;

    const from = stage.pointDict[data[0]];
    const to = stage.pointDict[data[1]];
    if (!from || !to) return;
    const line = new Konva.Line({
      id,
      points: [from.x, from.y, to.x, to.y],
      stroke: 'blue',
      strokeWidth: 2,
    });

    this.ele = new Konva.Group();
    this.ele.add(line);

    const image = new Image();
    image.src = PanoramaUrl.default;
    const direction1 = new Konva.Image({
      name: 'direction1',
      image,
      x: from.x + (to.x - from.x) / 3 * 2,
      y: from.y + (to.y - from.y) / 3 * 2,
      rotation: lineRad(from.x, from.y, to.x, to.y),
      width: 10,
      height: 10,
      offsetX: 5,
      offsetY: 5,
      visible: false,
    });
    const direction2 = new Konva.Image({
      name: 'direction2',
      image,
      x: from.x + (to.x - from.x) / 3,
      y: from.y + (to.y - from.y) / 3,
      rotation: lineRad(to.x, to.y, from.x, from.y),
      width: 10,
      height: 10,
      offsetX: 5,
      offsetY: 5,
      visible: false,
    });
    this.ele.add(direction1);
    this.ele.add(direction2);
    this.ele.id(this.id);

    const { path_direction } = this.property;
    if (path_direction === 'forward' || path_direction === 'twoward' || path_direction === 'forward_direction') {
      direction1.show();
    }
    if (path_direction === 'backward' || path_direction === 'twoward' || path_direction === 'backward_direction') {
      direction2.show();
    }

    this.ele.on('click', (e) => {
      stage.pointClickHandler(e);
    });

    stage.lineLayer.add(this.ele);
    this.layer = stage.lineLayer;

    return this.ele;
  }

  updateEle() {
    const from = this.stage.pointDict[this.data[0]];
    const to = this.stage.pointDict[this.data[1]];
    this.ele.children[0].points([from.x, from.y, to.x, to.y]);

    this.ele.children[1].x(from.x + 2 * (to.x - from.x) / 3);
    this.ele.children[1].y(from.y + 2 * (to.y - from.y) / 3);
    this.ele.children[1].rotation(lineRad(from.x, from.y, to.x, to.y));
    this.ele.children[2].x(from.x + (to.x - from.x) / 3);
    this.ele.children[2].y(from.y + (to.y - from.y) / 3);
    this.ele.children[2].rotation(lineRad(to.x, to.y, from.x, from.y));
  }

  setSelected(selected) {
    if (selected) {
      this.ele.children[0].stroke('#FF3B30');
    } else {
      this.ele.children[0].stroke('blue');
    }
  }
}

export default GraphicLine;
